import { render, staticRenderFns } from "./SimurationAmountDetail.vue?vue&type=template&id=c5a93d88"
import script from "./SimurationAmountDetail.vue?vue&type=script&lang=js"
export * from "./SimurationAmountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports